module.exports = __webpack_public_path__ + "img/upload-no.530113f7.png";